import { render, staticRenderFns } from "./DictionaryEdit.vue?vue&type=template&id=046a1940&scoped=true"
import script from "./DictionaryEdit.vue?vue&type=script&lang=js"
export * from "./DictionaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a1940",
  null
  
)

export default component.exports